import React from "react";
// TODO: Add react-helmet-async when React 19 support is available for SEO meta tags

import { useAuth } from "../contexts/AuthContext";
import StoreBanner from "../components/store-banner";
import "./LegalPages.css";

// Import existing assets
import logoImage from "../assets/dance_locale_3-200h.png";

const PrivacyPolicy = () => {
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="legal-page">
                        {/* TODO: Add SEO meta tags when react-helmet-async supports React 19
                Title: "Privacy Policy - Dance Locale" */}

            {/* Header using the same structure as other pages */}
            <div data-role="Header" className="home-header-container">
                <header className="home-header">
                    <a href="/" className="home-logo1">
                        <img alt="logo" src={logoImage} className="home-image1" />
                        <span className="nav-wordmark">Dance Localé</span>
                    </a>
                    <div className="home-menu1">
                        <a href="/" className="home-text10" style={{ cursor: "pointer", textDecoration: "none" }}>
                            Home
                        </a>
                        {user ? (
                            <>
                                {user.organisationId && (
                                    <a
                                        href="/dashboard"
                                        className="home-text12"
                                        style={{ cursor: "pointer", textDecoration: "none" }}>
                                        Dashboard
                                    </a>
                                )}
                                <a
                                    href="/my-hub"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    My Hub
                                </a>
                                <button onClick={handleLogout} className="home-text13" style={{ cursor: "pointer" }}>
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <a
                                    href="/login"
                                    className="home-text12"
                                    style={{ cursor: "pointer", textDecoration: "none" }}>
                                    Login
                                </a>
                                <a href="/contact" className="home-text13" style={{ textDecoration: "none" }}>Contact</a>
                            </>
                        )}
                    </div>
                    <div className="home-container11">
                        <StoreBanner />
                    </div>
                </header>
            </div>

            {/* Main content using AdminConsole structure */}
            {/* Main dashboard content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper">
                    <div className="dashboard-header-card">
                        <h1 className="admin-console-title">Privacy Policy</h1>
                        <p className="admin-console-description">
                            Last updated: 29 June 2026
                        </p>

                        <p className="legal-clause legal-lead">
                            Dance Localé is a multi-platform application that helps dancers discover dance events,
                            purchase tickets, book instructor sessions, and enrol in dance classes. We make it easy
                            to find and follow dance events across all styles including Zouk, Bachata, Salsa, and
                            more through our event discovery, ticketing, and class management platform.
                        </p>

                        {/* 1.0 Information We Collect */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">1.0 Information We Collect</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.1</span>
                                <strong>Account Information.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Email address for login</li>
                                <li>Username for identification</li>
                                <li>Password (securely encrypted)</li>
                                <li>Dance school/organiser status (if applicable)</li>
                            </ul>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.2</span>
                                <strong>Profile Photos and Images.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Profile avatar you choose to upload to your Dance Localé account</li>
                                <li>Instructor profile photo you upload to your public instructor profile</li>
                                <li>Organisation logo and cover photo uploaded to your school profile</li>
                            </ul>
                            <p className="legal-clause">
                                Images are stored on secure cloud servers. Your account profile photo may be visible to
                                dance schools you enrol with through the platform, so they can identify you at class
                                check-in. You can update or remove your profile photo at any time from your account
                                settings.
                            </p>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.3</span>
                                <strong>Dance Preferences.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Favourite dance styles</li>
                                <li>Event type preferences</li>
                                <li>Location for finding nearby events</li>
                            </ul>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.4</span>
                                <strong>Event Information.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Event details you create or import (name, description, date, location)</li>
                                <li>Calendar data (ICS files) you choose to import</li>
                                <li>Ticketing information for events you create</li>
                            </ul>

                            <p className="legal-clause">
                                <span className="legal-clause-num">1.5</span>
                                <strong>Usage Information.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>App feature usage</li>
                                <li>Location (with permission) for finding nearby events</li>
                                <li>Ticket purchase, class enrolment, and booking history</li>
                            </ul>
                        </div>

                        {/* 2.0 Data Deletion Rights */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">2.0 Data Deletion Rights</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">2.1</span>
                                <strong>How to Request Data Deletion.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>
                                    <strong>Account Deletion:</strong> You can request deletion of your Dance Localé
                                    account yourself: in the mobile app under Account, or on the web under Settings
                                    using "Request account deletion". Your account is scheduled for permanent deletion
                                    after a 30 day grace period, during which you can cancel the request by logging
                                    back in or using the emailed cancellation link. If you need help, contact us at
                                    support@dancelocale.com with the subject line "Account Deletion Request".
                                </li>
                                <li>
                                    <strong>Specific Data Removal:</strong> For requests to delete specific pieces of
                                    data while keeping your account active, please contact our support team with details
                                    of what you'd like removed.
                                </li>
                            </ul>

                            <p className="legal-clause">
                                <span className="legal-clause-num">2.2</span>
                                <strong>Data Deletion Timeline.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Account deletion requests: Processed within 30 days</li>
                                <li>Email confirmation sent once deletion is complete</li>
                                <li>Some data may be retained for legal compliance as outlined in our Terms</li>
                            </ul>
                        </div>

                        {/* 3.0 How We Use Your Information */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">3.0 How We Use Your Information</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">3.1</span>
                                We use your information to:
                            </p>
                            <ul className="legal-list">
                                <li>Show you relevant dance events in your area</li>
                                <li>Process ticket purchases, class enrolments, and instructor bookings</li>
                                <li>Remember your dance style preferences</li>
                                <li>Improve our event discovery and booking features</li>
                                <li>Send booking confirmations and class payment notifications</li>
                            </ul>
                        </div>

                        {/* 4.0 Data Protection */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">4.0 Data Protection</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">4.1</span>
                                Your data is protected by:
                            </p>
                            <ul className="legal-list">
                                <li>AWS secure cloud storage</li>
                                <li>HTTPS encryption</li>
                                <li>Regular security updates</li>
                                <li>Limited employee data access</li>
                                <li>Secure user authentication with encrypted passwords</li>
                                <li>PCI-compliant payment processing for ticket purchases</li>
                            </ul>
                        </div>

                        {/* 5.0 Your Control Over Data */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">5.0 Your Control Over Data</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">5.1</span>
                                You can:
                            </p>
                            <ul className="legal-list">
                                <li>Edit your profile anytime</li>
                                <li>Update dance preferences</li>
                                <li>Delete your account completely</li>
                                <li>Control location permissions</li>
                            </ul>
                        </div>

                        {/* 6.0 Data Retention */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">6.0 Data Retention</h2>

                            <p className="legal-clause">
                                <span className="legal-clause-num">6.1</span>
                                <strong>Your Account Data.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Account data stored until you delete your account</li>
                                <li>Event preferences stored until changed</li>
                                <li>Deleted accounts purged within 30 days</li>
                            </ul>

                            <p className="legal-clause">
                                <span className="legal-clause-num">6.2</span>
                                <strong>Student Profile Photos (School-Uploaded).</strong> Dance schools using the class
                                management features of Dance Localé may upload identification photos for their students.
                                These photos are:
                            </p>
                            <ul className="legal-list">
                                <li>Stored privately and visible only to staff of the uploading school</li>
                                <li>Never shared publicly or with other organisations on the platform</li>
                                <li>Used solely to help school staff identify students at check-in</li>
                                <li>Removed on the student's request and not retained longer than needed for the student's participation</li>
                            </ul>
                            <p className="legal-clause">
                                If you are a student and your school has uploaded a photo of you, you may ask your school
                                directly to remove you from their roster; doing so deletes the photo and removes your
                                identifying details from the school's records, while any payment records the school must
                                keep for tax and accounting are retained with your identity removed. You can also contact
                                us at support@dancelocale.com.
                            </p>

                            <p className="legal-clause">
                                <span className="legal-clause-num">6.3</span>
                                <strong>Event and Booking Data.</strong>
                            </p>
                            <ul className="legal-list">
                                <li>Event data stored until event completion or organiser deletion</li>
                                <li>Booking and ticket purchase records retained for accounting and compliance purposes</li>
                                <li>Past events may be removed after a period of inactivity</li>
                            </ul>
                        </div>

                        {/* 7.0 Third-Party Services */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">7.0 Third-Party Services</h2>

                            <ul className="legal-list">
                                <li>AWS for secure cloud storage and hosting</li>
                                <li>Stripe for payment processing (PCI-DSS compliant)</li>
                                <li>Google Maps for location services</li>
                            </ul>
                        </div>

                        {/* 8.0 Platform Compliance */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">8.0 Platform Compliance</h2>

                            <p className="legal-clause legal-lead">
                                Dance Localé operates in full compliance with:
                            </p>
                            <ul className="legal-list">
                                <li>Apple App Store Review Guidelines</li>
                                <li>Google Play Store Developer Policy</li>
                                <li>Australian Privacy Principles (APP)</li>
                                <li>General Data Protection Regulation (GDPR) where applicable</li>
                                <li>PCI Data Security Standards (PCI-DSS) for payment processing</li>
                            </ul>
                        </div>

                        {/* 9.0 Updates to Privacy Policy */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">9.0 Updates to Privacy Policy</h2>

                            <p className="legal-clause legal-lead">
                                We'll notify you of significant changes via:
                            </p>
                            <ul className="legal-list">
                                <li>Email notification</li>
                                <li>Website update</li>
                            </ul>
                        </div>

                        {/* 10.0 Contact For Support */}
                        <div className="legal-section">
                            <h2 className="legal-section-title">10.0 Contact For Support</h2>

                            <ul className="legal-list">
                                <li>
                                    <strong>Email:</strong> support@dancelocale.com
                                </li>
                                <li>
                                    <strong>Response time:</strong> Within 48 hours
                                </li>
                                <li>
                                    <strong>Based in:</strong> Australia
                                </li>
                            </ul>

                            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                <StoreBanner />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
